import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import Modal from '../Modal/Modal.jsx'
import Header from '../Modal/components/Header/Header.jsx'
import Menu from './components/Menu.js'
import UploadMedia from './components/UploadMedia.js'
import UploadBar from './components/UploadBar.js'
import MyLibrary from './views/MyLibrary/MyLibrary.js'
import UnsplashLibrary from './views/UnsplashLibrary/UnsplashLibrary.js'

import { ASSET_TABS } from './utils/constants'

import { ASSET_MANAGER__MANAGER_SET_TAB, ASSET_MANAGER__SET_PROJECT_ID } from '../../store/actions'

import './AssetManager.scss'

const AssetManager = ({ isOpen, onPlaceImage, onClose, projectId, settings = {}, t }) => {
    const { managerTab } = useSelector(state => state.assetManager)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(ASSET_MANAGER__SET_PROJECT_ID(projectId))
        dispatch(ASSET_MANAGER__MANAGER_SET_TAB(ASSET_TABS.TAB_MY_LIBRARY))
    }, [])

    const placeImageAndClose = (...args) => {
        onPlaceImage(...args)
        onClose()
    }

    return isOpen ? (
        <Modal closeOnOverlayClick={false} closeOnEsc={false}>
            <Header title={t('Add image')} onClose={onClose} />
            <div className="asset-manager__main">
                <div className="asset-manager__side-panel">
                    <Menu
                        className="asset-manager__menu"
                        currentTab={managerTab}
                        tabs={settings.managerTabs}
                        onSwitchTab={tab => dispatch(ASSET_MANAGER__MANAGER_SET_TAB(tab))}
                        t={t}
                    />
                    <UploadMedia className="asset-manager__upload-media" variant="primary" size="md">
                        {t('Upload media')}
                    </UploadMedia>
                </div>
                <div className="asset-manager__tab-space">
                    {managerTab === ASSET_TABS.TAB_MY_LIBRARY && (
                        <MyLibrary onPlaceImage={placeImageAndClose} sortTabs={settings.sortTabs} />
                    )}
                    {managerTab === ASSET_TABS.TAB_UNSPLASH_LIBRARY && (
                        <UnsplashLibrary onPlaceImage={placeImageAndClose} />
                    )}
                </div>
            </div>
            <UploadBar />
        </Modal>
    ) : null
}

export default withTranslation('translations')(AssetManager)
